import { createFileRoute } from "@tanstack/react-router";
import { VideoViewPage } from "@/components/v/VideoViewPage";

export const Route = createFileRoute("/v/$key")({
  component: RouteComponent,
});

function RouteComponent() {
  const { key } = Route.useParams();
  return <VideoViewPage mode="tracked" shareKey={key} />;
}
